import './sheet-item.scss';
import React, { useState } from "react"
import { LocalCharacterInitializer } from "../../../../../../entities/characters/Character";
import { DeleteIcon, MoveIcon } from '../../../../../icons';
import { MoveWindow } from './MoveItemWindow';
import { ExternalClickDetector } from '../../../../../../utils/events/ExternalClickDetector';
import { Loader } from '../../../../../theming/loader/Loader';
import { useAppDispatch, useAppSelector } from '../../../../../../store/configureStore';
import { CharacterSpecificActions } from '../../../../../../store/stores/collection/characters/actions/CharacterSpecificActions';
import { CharacterItemActions } from '../../../../../../store/stores/collection/characters/actions/CharacterItemActions';
import { OwnedItemReference } from '../../../../../../entities/Ownership';
import { ItemHelpers } from '../../../../../../entities/library/items/Item';

type Props = {
    character: LocalCharacterInitializer;
    reference: OwnedItemReference;
}

export const SheetItem: React.FC<Props> = (props: Props) => {
    const { character, reference } = props;
    const allItems = useAppSelector(app => app.library.items);
    const item = allItems.find(i => i.id == reference.id);
    if (item == null) {
        throw "Item not found.";
    }

    const itemSaved = character.pendingProperties[reference.instanceId] == null;
    let itemClass = itemSaved ? 'saved' : 'pending';
    const dispatch = useAppDispatch();
    const [moveOpen, setMoveOpen] = useState<boolean>(false);

    const onItemClick = () => {
        if (itemSaved) {
            dispatch(CharacterSpecificActions.setPreviewItem(character, reference.instanceId))
        }
    }
    return (
        <div className={`sheet-item ${itemClass}`}>
            <div className='item-column-container'>
                <div className="icon">
                    {!itemSaved && <Loader size="S" />}
                    {itemSaved && 
                        <div className="move-item-container">
                            <button className="interactable-button" onClick={() => setMoveOpen(true)}>
                                <MoveIcon />
                            </button>
                            {moveOpen && (
                                <ExternalClickDetector onExternalClickDetected={() => setMoveOpen(false)}>
                                    <MoveWindow character={character} reference={reference} />
                                </ExternalClickDetector>
                            )}
                        </div>
                    }
                </div>
                <div className="icon" onClick={onItemClick}>{ItemHelpers.getIcon(item)}</div>
                <div className="name" onClick={onItemClick}>{ItemHelpers.getName(item, reference)}</div>
                <div className="cost" onClick={onItemClick}>{item.cost}</div>
                <div className="weight" onClick={onItemClick}>{item.weight}</div>
                <div className="tags" onClick={onItemClick}>{ItemHelpers.getTagText(item)}</div>
                <div className="icon">
                    <button className="interactable-button" onClick={() => dispatch(CharacterItemActions.removeItem(character, reference))}>
                        <DeleteIcon />
                    </button>
                </div>
            </div>
        </div>
    );
}